module.exports = __webpack_public_path__ + "static/media/mansura_thumb_even.93fb1836.webp";